import { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import CustomButton from "../../../component/elements/CustomButton/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../../../configuration/request";
import { useSnackbar } from "../../../component/SnackbarContext";

function ManualPayoutStatus({ onClose, onSubmit, dialogDetails }) {
  const showSnackbar = useSnackbar();
  const [remarks, setRemarks] = useState("Marked paid manually");
  const [submitting, setSubmitting] = useState(false);
  const payoutId = dialogDetails?.id;

  useEffect(() => {
    if (payoutId != null) {
      setRemarks("Marked paid manually");
    }
  }, [payoutId]);

  const handleSubmit = () => {
    const trimmed = remarks.trim();
    if (!trimmed) {
      showSnackbar("Please enter remarks.", "error");
      return;
    }
    if (payoutId == null) {
      showSnackbar("Missing payout id.", "error");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .patch(`/payment/manual-status/${payoutId}`, { remarks: trimmed })
      .then(() => {
        showSnackbar("Payout marked as manually paid.", "success");
        onSubmit?.();
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="pt-6 px-6 pb-4">
      <div className="flex justify-between mb-4">
        <div className="text-base xs:text-lg font-[500] text-[var(--primary-text-color)]">
          Mark payout manually paid
        </div>
        <button
          type="button"
          className="hidden xs:block text-gray-600 hover:text-black"
          onClick={onClose}
          aria-label="Close"
        >
          <CloseIcon />
        </button>
      </div>
      <p className="text-sm text-[var(--light-text-color)] mb-4">
        Use this when a failed payout was settled outside the platform. Status
        will be updated to reflect a manual payment.
      </p>
      <TextField
        fullWidth
        multiline
        minRows={2}
        label="Remarks"
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        size="small"
        placeholder="e.g. Paid via bank transfer — reference #1234"
        sx={{ mb: 2 }}
      />
      <div className="flex flex-col xs:flex-row justify-center items-center gap-3 pt-2">
        <CustomButton
          onClick={onClose}
          disabled={submitting}
          customeClass="primary-custom-button w-full xs:w-[150px] h-[40px]"
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={handleSubmit}
          disabled={submitting}
          customeClass="gradient-button w-full xs:w-[150px] h-[40px]"
        >
          {submitting ? "Saving…" : "Confirm"}
        </CustomButton>
      </div>
    </div>
  );
}

export default ManualPayoutStatus;
